export default {
  'Resolution': 'Çözünürlük',
  'Frame rate': 'Kare hızı',
  'The higher the frame rate, the smoother the animation': 'Daha yüksek kare hızı, pürüzsüz animasyon.',
}